import { createLogger } from '@eventstore-ui/utils';

export const logger = createLogger(
    '@eventstore-ui/fields',
    'linear-gradient(-225deg, #231557 0%, #44107A 29%, #FF1361 67%, #FFF800 100%);',
);
